import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import MapComponent from "./MapComponent";
import Delete from "/Delete1.png?url";
import Map from "/map.png?url";
import { Bar } from "react-chartjs-2";
import { Stepper, Step, StepLabel, styled } from "@mui/material";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";

// สไตล์สำหรับ StepConnector
const CustomConnector = styled(StepConnector)(({ theme, activeStep }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
  },
  [`&.${stepConnectorClasses.line}`]: {
    borderColor: activeStep === 0 ? "#E4E7EC" : "#2762F8", // สีเส้นที่ต่างกันตาม step
    borderTopWidth: 2,
    borderRadius: 1,
  },
  ...(activeStep === 1 && {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#2762F8", // สีเส้นเมื่อ active
    },
  }),
}));

const CustomStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
  zIndex: 1,
  color: "#2762F8",
  width: 20,
  height: 20,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    backgroundColor: "#2762F8",
  }),
  ...(ownerState.completed && {
    backgroundColor: "#2762F8",
  }),
}));

function CustomStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    1: <div></div>, // ไอคอนที่ต้องการแสดง
    2: <div></div>,
  };

  return (
    <CustomStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {icons[String(props.icon)]}
    </CustomStepIconRoot>
  );
}

const AddBranchModal = ({ closeModal, onSuccess }) => {
  const [branchCode, setBranchCode] = useState("");
  const [branchName, setBranchName] = useState("");
  const [location, setLocation] = useState("");
  const [lat, setLat] = useState(null);
  const [lng, setLng] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [timeInputs, setTimeInputs] = useState([]);
  const [page, setPage] = useState(1);
  const [showMap, setShowMap] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [isLightActive, setIsLightActive] = useState(false);
  const [useCurrentLocation, setUseCurrentLocation] = useState(false);
  const [showMapButton, setShowMapButton] = useState(true);

  const mapRef = useRef(null);
  const markerRef = useRef(null);

  const handleUseCurrentLocationChange = (event) => {
    const isChecked = event.target.checked;
    setUseCurrentLocation(isChecked);
    if (isChecked) {
      getCurrentLocation();
    } else {
      setLocation("");
      setLat("");
      setLng("");
    }
  };

  const getCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          setLat(latitude.toFixed(6));
          setLng(longitude.toFixed(6));

          try {
            const response = await axios.get(
              `https://nominatim.openstreetmap.org/reverse`,
              {
                params: {
                  lat: latitude,
                  lon: longitude,
                  format: "json",
                },
              }
            );
            setLocation(response.data.display_name);

            if (mapRef.current) {
              mapRef.current.setView([latitude, longitude], 13);
              let marker = markerRef.current;
              if (marker) {
                marker.setLatLng([latitude, longitude]);
              } else {
                marker = L.marker([latitude, longitude], {
                  draggable: true,
                }).addTo(mapRef.current);
                markerRef.current = marker;
              }
            }
          } catch (error) {
            console.error("Error fetching address from coordinates:", error);
          }
        },
        (error) => {
          console.error("Error getting current location:", error);
        }
      );
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  };

  useEffect(() => {
    if (useCurrentLocation) {
      getCurrentLocation();
    }
  }, [useCurrentLocation]);

  const submitBranchData = async () => {
    const branchData = {
      code: branchCode,
      name: branchName,
      schedule_light_bulbs_active: isLightActive,
      active: isActive,
      lat,
      lng,
      location,
      schedule_light_bulbs: timeInputs.map((input) => ({
        period: input.timeValue,
        brightness: input.rangeValue,
      })),
    };

    try {
      const response = await axios.post(
        `${import.meta.env.VITE_API_URL}/branches`,
        branchData
      );
      console.log("Branch added successfully:", response.data);
      closeModal();
      if (onSuccess && response.data && response.data.branch) {
        onSuccess(response.data.branch.id);
      }
    } catch (error) {
      console.error("Failed to add branch:", error);
    }
  };

  const handleNextPage = () => {
    setPage(page + 1);
  };

  const handlePreviousPage = () => {
    setPage(page - 1);
  };

  const handleAddTimeClick = (event) => {
    event.preventDefault();
    const newInput = {
      id: Date.now(),
      rangeValue: 0,
      timeValue: "",
    };
    setTimeInputs(timeInputs.concat(newInput));
  };

  const handleRangeChange = (id, newValue) => {
    setTimeInputs(
      timeInputs.map((input) => {
        if (input.id === id) {
          return { ...input, rangeValue: newValue };
        }
        return input;
      })
    );
  };

  const handleRemoveTimeInput = (idToRemove) => {
    setTimeInputs(timeInputs.filter((input) => input.id !== idToRemove));
  };

  function timeToMinutes(timeValue) {
    const [hours, minutes] = timeValue.split(":").map(Number);
    return hours * 60 + minutes;
  }

  const sortedTimeInputs = [...timeInputs].sort((a, b) => {
    const timeA = a.timeValue ? timeToMinutes(a.timeValue) : Infinity;
    const timeB = b.timeValue ? timeToMinutes(b.timeValue) : Infinity;
    return timeA - timeB;
  });

  function minutesToTime(minutes) {
    if (minutes < 0) {
      minutes = 23 * 60 + 59;
    }
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours.toString().padStart(2, "0")}:${mins
      .toString()
      .padStart(2, "0")}`;
  }

  const labels = sortedTimeInputs.map((input, index) => {
    if (index < sortedTimeInputs.length - 1) {
      const nextTimeInMinutes =
        timeToMinutes(sortedTimeInputs[index + 1].timeValue) - 1;
      const adjustedNextTime = minutesToTime(nextTimeInMinutes);
      return `${input.timeValue} - ${adjustedNextTime}`;
    } else {
      const firstTimeInMinutes =
        timeToMinutes(sortedTimeInputs[0].timeValue) - 1;
      const adjustedFirstTime = minutesToTime(firstTimeInMinutes);
      return `${input.timeValue} - ${adjustedFirstTime}`;
    }
  });

  const chartData = {
    labels,
    datasets: [
      {
        data: sortedTimeInputs.map((input) => input.rangeValue),
        backgroundColor: "#F5B81C",
      },
    ],
  };

  const handleTimeChange = (id, newTimeValue) => {
    setTimeInputs(
      timeInputs.map((input) =>
        input.id === id ? { ...input, timeValue: newTimeValue } : input
      )
    );
  };

  const options = {
    scales: {
      x: {
        ticks: {
          color: "white",
        },
        grid: {
          color: "transparent",
        },
      },
      y: {
        position: "right",
        beginAtZero: true,
        ticks: {
          color: "white",
          callback: function (value) {
            return value + "%";
          },
        },
        min: 0,
        max: 100,
        grid: {
          color: "rgba(255, 255, 255, 0.1)",
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
    maintainAspectRatio: false,
    responsive: true,
  };

  const handleToggleChange = () => {
    setIsActive(!isActive);
  };

  const handleToggleLightChange = () => {
    setIsLightActive(!isLightActive);
  };

  const handleConfirmation = () => {
    setShowConfirmation(true);
  };

  const handleConfirmationClose = () => {
    setShowConfirmation(false);
  };

  const handleLocationSelect = (selectedData) => {
    setLocation(selectedData.location);
    setLat(selectedData.lat);
    setLng(selectedData.lng);
  };

  const renderFloatLabelInput = (
    label,
    type,
    name,
    id,
    value,
    onChange,
    required = true
  ) => (
    <div className="float-label-container">
      <input
        type={type}
        id={id}
        name={name}
        value={value || ""}
        onChange={onChange}
        className="input-required"
        required={required}
        placeholder=" "
      />
      <label htmlFor={id}>
        {label} {required && <span className="required-asterisk"> *</span>}
      </label>
    </div>
  );

  const handleCloseMap = () => {
    setShowMap(false);
  };

  return (
    <>
      {page === 1 && (
        <div className="BranchModal">
          <div className="BranchModalContent">
            <h2>เพิ่มสาขา</h2>
            <form className="addbranch">
              <div className="statebranch">
                <Stepper
                  className="stepper"
                  activeStep={page - 1}
                  alternativeLabel
                  connector={<CustomConnector activeStep={page - 1} />} // ส่ง activeStep เข้าไปใน CustomConnector
                >
                  <Step key="1">
                    <StepLabel StepIconComponent={CustomStepIcon}>
                      เพิ่มข้อมูลสาขา
                    </StepLabel>
                  </Step>
                  <Step key="2">
                    <StepLabel StepIconComponent={CustomStepIcon}>
                      ตรวจสอบข้อมูลสาขา
                    </StepLabel>
                  </Step>
                </Stepper>
              </div>
              <label>ข้อมูลสาขา</label>
              <div className="titleBranch">
                {renderFloatLabelInput(
                  "รหัสสาขา",
                  "text",
                  "branchCode",
                  "branchCode",
                  branchCode,
                  (e) => setBranchCode(e.target.value)
                )}

                {renderFloatLabelInput(
                  "ชื่อสาขา",
                  "text",
                  "branchName",
                  "branchName",
                  branchName,
                  (e) => setBranchName(e.target.value)
                )}

                <div className="relativMap">
                  {renderFloatLabelInput(
                    "สถานที่ตั้ง",
                    "text",
                    "location",
                    "location",
                    location,
                    (e) => setLocation(e.target.value)
                  )}

                  {!location && !lat && !lng && showMapButton && (
                    <img
                      src={Map}
                      alt="เลือกจากแผนที่"
                      onClick={() => setShowMap(!showMap)}
                    />
                  )}
                  <div className="up2">
                    <div className="checkbox-container">
                      <input
                        type="checkbox"
                        id="useCurrentLocation"
                        onChange={handleUseCurrentLocationChange}
                        checked={useCurrentLocation}
                      />
                      <label
                        htmlFor="useCurrentLocation"
                        className="label-useCurrentLocation"
                      >
                        ใช้ตำแหน่งปัจจุบัน
                      </label>
                    </div>
                  </div>
                </div>

                {renderFloatLabelInput(
                  "ละติจูด",
                  "text",
                  "lat",
                  "lat",
                  lat,
                  (e) => setLat(parseFloat(e.target.value)),
                  true
                )}
                {renderFloatLabelInput(
                  "ลองจิจูด",
                  "text",
                  "lng",
                  "lng",
                  lng,
                  (e) => setLng(parseFloat(e.target.value)),
                  true
                )}
              </div>
              <div className="toggle-switch-container">
                <span>{isActive ? "เปิด" : "ปิด"}การใช้งานสาขา</span>

                <label className="toggle-switch">
                  <input
                    type="checkbox"
                    checked={isActive}
                    onChange={handleToggleChange}
                  />
                  <span className="slider"></span>
                </label>
              </div>
              <label>ปรับความสว่างหลอดไฟแบบอัตโนมัติ (ค่าเริ่มต้น)</label>

              <div className="toggle-switch-container">
                <span>{isLightActive ? "ทำงานปกติ" : "หยุดทำงาน"}</span>
                <label className="toggle-switch">
                  <input
                    type="checkbox"
                    checked={isLightActive}
                    onChange={handleToggleLightChange}
                  />
                  <span className="slider"></span>
                </label>
              </div>

              <div className="add-time-button-container">
                <button
                  className="add-time-button"
                  onClick={handleAddTimeClick}
                >
                  + เพิ่มเวลา
                </button>
              </div>
            </form>
            {timeInputs.map((input) => (
              <div key={input.id} className="time-input-container">
                <label>เวลา</label>
                <input
                  type="time"
                  className="time-display"
                  value={input.timeValue}
                  onChange={(e) => handleTimeChange(input.id, e.target.value)}
                />

                <div
                  className="slider-container"
                  style={{ position: "relative" }}
                >
                  <input
                    type="range"
                    min="0"
                    max="100"
                    value={input.rangeValue}
                    className="gradient-range"
                    onChange={(e) =>
                      handleRangeChange(input.id, e.target.value)
                    }
                  />
                  <div
                    className="value-display"
                    style={{
                      left: `calc(${input.rangeValue}% + 10px)`,
                      transform: "translateX(-50%)",
                      bottom: "-15px",
                    }}
                  >
                    {input.rangeValue}%
                  </div>
                </div>

                <button
                  className="delete-button"
                  onClick={() => handleRemoveTimeInput(input.id)}
                >
                  <img src={Delete} alt="Delete" />
                </button>
              </div>
            ))}
            {timeInputs.some((input) => input.timeValue) && (
              <div className="setlight chartContainer">
                <Bar data={chartData} options={options} />
              </div>
            )}
            <div className="addbranh_button">
              <div className="button-adduser">
                <button className="cancel-button" onClick={closeModal}>
                  ยกเลิก
                </button>
                <button className="confirm-button" onClick={handleNextPage}>
                  ถัดไป
                </button>
              </div>
            </div>
          </div>
          {showMap && (
            <MapComponent
              onLocationSelect={handleLocationSelect}
              onClose={handleCloseMap}
            />
          )}
        </div>
      )}
      {page === 2 && (
        <div className="BranchModal">
          <div className="BranchModalContent">
            <h2>เพิ่มสาขา</h2>

            <form className="addbranch">
              <div className="statebranch">
                <Stepper
                  className="stepper"
                  activeStep={page - 1}
                  alternativeLabel
                  connector={<CustomConnector activeStep={page - 1} />}
                >
                  <Step key="1">
                    <StepLabel StepIconComponent={CustomStepIcon}>
                      เพิ่มข้อมูลสาขา
                    </StepLabel>
                  </Step>
                  <Step key="2">
                    <StepLabel StepIconComponent={CustomStepIcon}>
                      ตรวจสอบข้อมูลสาขา
                    </StepLabel>
                  </Step>
                </Stepper>
              </div>
              <strong style={{ color: "#2762F8" }}>ข้อมูลสาขา</strong>

              <div className="branch-info-container">
                <div className="branch-info">
                  <label>รหัสสาขา </label>
                  <strong>{branchCode}</strong>
                </div>
                <div className="branch-info">
                  <label>ชื่อสาขา </label>
                  <strong>{branchName}</strong>
                </div>
                <div className="branch-info">
                  <label>สถานะสาขา </label>
                  <strong style={{ color: isActive ? "#3DCC85" : "#F2274C" }}>
                    {isActive ? "เปิดใช้งานสาขา" : "ยังไม่เปิดใช้งานสาขา"}
                  </strong>
                </div>

                <div className="branch-info">
                  <label>ละติจูด </label>
                  <strong>{lat}</strong>
                </div>
                <div className="branch-info">
                  <label>ลองจิจูด </label>
                  <strong>{lng}</strong>
                </div>
                <div className="branch-info">
                  <label>สถานที่ตั้ง </label>
                  <strong>{location}</strong>
                </div>
              </div>

              <li>ปรับความสว่างหลอดไฟแบบอัตโนมัติ (ค่าเริ่มต้น)</li>
            </form>

            {timeInputs.some((input) => input.timeValue) && (
              <div className="setlight chartContainer">
                <Bar data={chartData} options={options} />
              </div>
            )}
            <div className="addbranh_button">
              <div className="button-adduser">
                <button className="cancel-button" onClick={handlePreviousPage}>
                  ยกเลิก
                </button>
                <button className="confirm-button" onClick={handleConfirmation}>
                  ยืนยัน
                </button>
              </div>
            </div>
          </div>

          {showConfirmation && (
            <div className="BranchModal">
              <div className="ConfirmationModal">
                <h2>ยืนยันการเพิ่มสาขา '{branchName}' ?</h2>
                <div className="button-adduser">
                  <button
                    className="cancel-button"
                    onClick={handleConfirmationClose}
                  >
                    ยกเลิก
                  </button>

                  <button
                    className="confirm-button"
                    onClick={() => {
                      handleConfirmationClose();
                      submitBranchData();
                    }}
                  >
                    ยืนยัน
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default AddBranchModal;
